module.exports = __webpack_public_path__ + "static/tafel-ritorno-landscape-e5eb21ad1bafdacc2b57edc28ab75c0f.jpg";